import React from 'react';

const Title = ({title}) => {  
    return (
        <h1 className="text-2xl lg:text-4xl text-center mb-20 font-bold mx-4 whitespace-nowrap">- {title} -</h1>
    );
}

export default Title;